// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","QualityCheckboxes":"ex_a bht_j bht_i bht_bc bht_r bht_st","QualityCheckboxes__quality":"ex_b"};